<div class="m-4">
  <h2>Propriété de {{ UserHelper.userSummmaryDisplayName(prop.owner) }}</h2>
</div>
<div *ngFor="let alert of alerts" class="col-12 col-lg-6 offset-lg-3 d-flex justify-content-center" role="alert">
  <mat-icon class="align-bottom" color="warn">warning</mat-icon>
  <span class="ml-2">{{ alert }} !</span>
</div>
<div class="col-12">
  <div class="row">
    <div class="property-form-group">
      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>Photo</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="text-center">
            <img class="img-fluid" [src]="mainPhoto" alt="Photo principale du bien"
              appTooltip="Photo principale du bien" />
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="property-form-group">
      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>Caractéristiques principales</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="property-field-group">
            <div class="property-field-container col-12 col-md-6 col-xl-4">
              <div class="property-field">
                <span class="property-field-title">Type de bien</span><span class="property-field-value">{{
                  propertyHelper.getTypeName(prop.type) }}</span>
              </div>
            </div>
            <div *ngFor="let attr of rescueAttrsDict" class="property-field-container col-12 col-md-6 col-xl-4">
              <div class="property-field">
                <span class="property-field-title">{{ dictHelper.getAttrNameDisplay(attr) }}</span><span
                  class="property-field-value">{{
                  rescueAttrs[attr.code]
                  ? dictHelper.getAttrValueDisplay(attr, rescueAttrs[attr.code].value)
                  : 'Non renseigné'
                  }}</span>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="property-form-group">
      <app-property-people-table [prop]="prop" rescueMode="true"></app-property-people-table>
    </div>
    <div class="property-form-group">
      <app-property-doc-view [prop]="prop" rescueMode="true"></app-property-doc-view>
    </div>
  </div>
</div>
